import { render, staticRenderFns } from "./originalWorks.vue?vue&type=template&id=2eccc1f4&scoped=true&"
import script from "./originalWorks.vue?vue&type=script&lang=js&"
export * from "./originalWorks.vue?vue&type=script&lang=js&"
import style0 from "./originalWorks.vue?vue&type=style&index=0&id=2eccc1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eccc1f4",
  null
  
)

export default component.exports